import React from "react";
import { GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/content";
export function BonusesSection() {
  return <section className="w-full bg-navy-900 py-16 sm:py-24" data-id="element-98" data-mp="qe0t16u5zj1u">
      <div className="mx-auto max-w-5xl" data-id="element-99" data-mp="vbahok9qbqom">
        <div className="px-5" data-id="element-100" data-mp="vcc4fm03y1m6">
          <SectionHeading tone="dark" eyebrow="Included free" title={<>5 exclusive bonuses — <em className="text-gold-400" data-id="element-102" data-mp="1j3hlu5lp51yl">yours free today</em></>} data-id="element-101" data-mp="vdn6nhdwn1b6" />
        </div>

        <div className="mt-10 space-y-6 sm:space-y-10 sm:px-5" data-id="element-103" data-mp="1nzyad0wt5ic7">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-navy-800 sm:rounded-3xl md:grid md:grid-cols-2 md:items-center" data-id="element-104" data-mp="19b21x2qua3b2">
              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="block w-full bg-white" data-id="element-105" data-mp="1e8bq6f2hs8xb" />
              <div className="px-5 py-7 sm:p-8" data-id="element-106" data-mp="26qz6lh6jmzs2">
                <p className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-[0.14em] text-gold-400" data-id="element-107" data-mp="26rr1epsbgtha">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="2m5s8ukb0j6lj" />
                  Bonus #{b.number}
                </p>
                <h3 className="mt-2 font-serif text-2xl font-bold leading-tight text-white sm:text-3xl" data-id="element-109" data-mp="2vvbqjmmzouet">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-white/80" data-id="element-110" data-mp="2r422gqh39z51">{b.text}</p>
                <p className="mt-5 inline-flex items-center gap-3 rounded-xl bg-navy-950 px-4 py-2.5" data-id="element-111" data-mp="34vqbgkw1k7hs">
                  <span className="text-base text-white/60 line-through" data-id="element-112" data-mp="2zx5klc2oj060">Value: ${b.value}</span>
                  <span className="text-lg font-extrabold uppercase text-gold-400" data-id="element-113" data-mp="3etwbsy2795kj">Free</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl px-5" data-id="element-114" data-mp="39t8p2ol07aw4">
          <CTAButton label="I want all 5 bonuses" data-id="element-115" data-mp="1kgy5epjmet2h" />
        </div>
      </div>
    </section>;
}